// FE-SCRM-057 — Proposal artifact REST client.
//
// Wraps the six BE-SCRM-029 endpoints under /api/v1/sales/:
//
//   POST /opportunities/{id}/proposals            (multipart upload)
//   GET  /opportunities/{id}/proposals            (list)
//   GET  /proposals/{id}                          (detail)
//   GET  /proposals/{id}/download                 (presigned download URL)
//   POST /proposals/{id}/mark-sent
//   POST /proposals/{id}/mark-response
//
// Upload is multipart/form-data with a ``file`` field (PDF) plus
// optional ``notes`` form field. The other endpoints take / return
// JSON.

import { api } from "@/api/client";

import type {
  DownloadProposalResponse,
  MarkResponseInput,
  MarkSentInput,
  Proposal,
  ProposalListResponse,
} from "./types";


export function fetchProposalsList(
  opportunity_id: string,
  opts?: { signal?: AbortSignal },
): Promise<ProposalListResponse> {
  return api.get<ProposalListResponse>(
    `/api/v1/sales/opportunities/${opportunity_id}/proposals`, opts,
  );
}


export function uploadProposal(
  opportunity_id: string,
  input: { file: File; notes?: string | null },
): Promise<Proposal> {
  const form = new FormData();
  form.append("file", input.file);
  if (input.notes) form.append("notes", input.notes);
  return api.post<Proposal>(
    `/api/v1/sales/opportunities/${opportunity_id}/proposals`,
    form,
  );
}


export function fetchProposalDownload(
  proposal_id: string,
): Promise<DownloadProposalResponse> {
  return api.get<DownloadProposalResponse>(
    `/api/v1/sales/proposals/${proposal_id}/download`,
  );
}


export function markProposalSent(
  proposal_id: string, input: MarkSentInput,
): Promise<Proposal> {
  return api.post<Proposal>(
    `/api/v1/sales/proposals/${proposal_id}/mark-sent`, input,
  );
}


export function markProposalResponse(
  proposal_id: string, input: MarkResponseInput,
): Promise<Proposal> {
  return api.post<Proposal>(
    `/api/v1/sales/proposals/${proposal_id}/mark-response`, input,
  );
}
